import Container from "../../components/Container";
import {useState} from "react";
import {IoIosArrowDown} from "react-icons/io";

export default function Difference() {

    const [activeAccordion, setActiveAccordion] = useState("");

    const onClickAccordion = (accordion) => {
        if (activeAccordion === accordion) {
            setActiveAccordion("");
        } else {
            setActiveAccordion(accordion);
        }
    }

    return <Container
        transparent
        padding={""}
        shadow={false}
    >
        {/*For Large Screens*/}
        <div className="md:grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-4">
            <div className="col-span-4 w-full px-2">
                <h2 className={"text-2xl font-bold text-center md:text-left my-4"}>Why are We Different?</h2>
                <h4 className={"my-2"}>2022 Financial Intelligence Authority (FIA) report found that real estate industry is most
                    vulnerable to risks and money laundering due to unregistered players.</h4>
                <h5>That's why we work with:</h5>


                <div data-active-classes="bg-white text-gray-900">
                    <h2>
                        <button
                            className="flex items-center justify-between w-full py-5 font-medium rtl:text-right text-gray-800 border-b border-gray-200 gap-3"
                            onClick={() => onClickAccordion("accordion-1")}>
                            <span>Registered Property Valuers Only</span>
                            <IoIosArrowDown/>
                        </button>
                    </h2>
                    <div className={activeAccordion === "accordion-1" ? "" : 'hidden'}>
                        <div className="py-5 border-b border-gray-200">
                            <p className="mb-2 text-gray-800">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. A assumenda consequatur
                                delectus ducimus earum, harum ipsa iste iusto magnam molestias numquam odit praesentium
                                quisquam recusandae reprehenderit sequi similique tenetur ullam.
                            </p>
                        </div>
                    </div>

                    <h2>
                        <button
                            className="flex items-center justify-between w-full py-5 font-medium rtl:text-right text-gray-800 border-b border-gray-200 gap-3"
                            onClick={() => onClickAccordion("accordion-2")}>
                            <span>Registered Estate Agents Only</span>
                            <IoIosArrowDown/>
                        </button>
                    </h2>
                    <div className={activeAccordion === "accordion-2" ? "" : 'hidden'}>
                        <div className="py-5 border-b border-gray-200">
                            <p className="mb-2 text-gray-800">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab cum dignissimos distinctio
                                ducimus ex exercitationem illo, libero molestiae molestias, officia porro, possimus
                                quaerat quam qui quos ratione similique veniam voluptate!
                            </p>
                        </div>
                    </div>

                    <h2>
                        <button
                            className="flex items-center justify-between w-full py-5 font-medium rtl:text-right text-gray-800 border-b border-gray-200 gap-3"
                            onClick={() => onClickAccordion("accordion-3")}>
                            <span>Support Property Scouts to become Registered Estate Agents</span>
                            <IoIosArrowDown/>
                        </button>
                    </h2>
                    <div className={activeAccordion === "accordion-3" ? "" : 'hidden'}>
                        <div className="py-5 border-b border-gray-200">
                            <p className="mb-2 text-gray-800">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias aperiam aspernatur ea
                                eaque eos est ex excepturi id ipsum nisi nobis, nostrum numquam praesentium quia saepe
                                sed temporibus? At, debitis?
                            </p>
                        </div>
                    </div>
                </div>


            </div>

            <div className={"col-span-2 w-full rounded-3xl md:overflow-hidden relative"}>
                <img src="img/musa-ortac-HrrWNCpoOu8-unsplash.jpg"
                     className="w-full absolute md:left-1/2 md:top-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2"
                     alt="cover-image"
                />
            </div>
        </div>

        <div className={"w-[100vw]"}></div>
    </Container>
}